/* globals $:false, Bloodhound:false */

import UriBuilder from "../helpers/module.uribuilder";
import IndexedInstanceM from '../model/recordm.model.entity.indexedinstance.js';

import { sprintf } from 'sprintf-js';

import tmpl from '../templates/search-unified-entity.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// Component capable of handling Ref fields.
//
// args:
// * `definition`: the definition name to load instances
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A string space separated with a list of css classes to add to the input
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user selects a result
//
// * `query`: query to use in the auto complete. Defaults to '*'
// * `header`: The header of the suggestions box
// * `maxRows`: Then number of results
//
const Ref = function(core, definition, confs) {

    var _loadingKey = core.getLoadingKey();

    var _$html, _$input,
        _lastQuery,
        _currentQuery,
        _numSearchResults,
        _totalSearchResults,
        _from = 0;

    let _previousStyle = "";

    var _selectedIndexedInstance,
        _labelWhileStillLoading = '',
        _valueWhileStillLoading;

    var _typeaheadQueryEngine;

    var _confs = {
        id: core.locallyUniqueId(),
        fieldDefinition: {name: ""},
        cssClasses: undefined,
        readonly: false,
        valueChanged: undefined,

        query: '*',
        header: core.translateString("recordm.search", "search.select-record"),
        maxRows: 5
    };

    // we fallback to the default maxRows
    if(!confs.maxRows){
       confs.maxRows = _confs.maxRows
    }

    utils.extend(_confs, confs, true);

    var _loadReference = function(value) {
        if (value) {
            core.showLoading(_loadingKey, 'get reference instance');

            IndexedInstanceM.get(core, value, {
                forceReload: true,
                success: function(indexedInstanceM) {
                   // we use the smallest timeout so that fields that
                   // listen for changes are all already listening
                   setTimeout(() => {
                      _onSelect(undefined, {entity: indexedInstanceM});

                      core.hideLoading(_loadingKey, 'get reference instance success');
                   }, 10);
                },
                error: function() {
                    core.hideLoading(_loadingKey, 'get reference instance error');
                }
            });
        }
    };

    var _resetCounters = function(){
        _from = 0;
        _numSearchResults = 0;
        _totalSearchResults = 0;
    };

    var _onSelect = function(e, record) {
        var instanceLabel;

        _resetCounters();

        _labelWhileStillLoading = '';
        _valueWhileStillLoading = undefined;
        _selectedIndexedInstance = record.entity;

        _addRefLink();

        if (_$input) {

            instanceLabel = _selectedIndexedInstance.getInstanceLabel();
            if (!_confs.readonly) {
                //TODO jbarata: hack to workaround the https://github.com/twitter/typeahead.js/issues/646
                if(_$input.data('ttTypeahead')){ //if the presenter was destroyed, there's no longer a value for the attribute
                    var typeaheadInput = _$input.data('ttTypeahead').input;
                    typeaheadInput.setQuery(instanceLabel);
                    typeaheadInput.resetInputValue();
                }
                // /*qd o issue for corrigido deve ficar esta linha em vez das 3 acima*/ _$input.typeahead('val', instanceLabel);
                //fim do hack

                _lastQuery = instanceLabel;

            } else {
                _$input.val(instanceLabel);
            }
        }

        if (_confs.valueChanged) {
            _confs.valueChanged(record);
        }
    };

    var _onClose = function() {
        _resetCounters();

        // The query changed so let's clean the selected instance
        _lastQuery = _lastQuery || '';

        if (_lastQuery.trim() !== _$input.val().trim()) {
            _selectedIndexedInstance = undefined;
            _$input.typeahead('val', '');

            _removeRefLink();

            // let's notify that the selected value changed
            _confs.valueChanged(undefined);
        }
    };

    var _parseResponse = function(response) {
        _totalSearchResults = response.hits.total.value;
        _numSearchResults = response.hits.hits.length;

        // update the response with the new response
        return response.hits.hits.map(function(hit) {
            var indexedInstanceM = new IndexedInstanceM(core, hit._source);

            return  {
                entity: indexedInstanceM,
                title: indexedInstanceM.getInstanceLabel(),
                details: indexedInstanceM.getInstanceDescription(core.getLocale())
            }
        });
    };

    var _addTypeAheadToInput = function() {

        _typeaheadQueryEngine = new Bloodhound({
            datumTokenizer: function(d) { return Bloodhound.tokenizers.whitespace(d.title); },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            limit: _confs.maxRows,
            remote: {
                url: _getSearchUrl(),
                replace: function(uri, query){
                   let _lastUri =  uri;
                   // we need to detect query changes, discarding the fake * added at the end by _refreshSuggestions
                   if(query !== _currentQuery && query !== _currentQuery + '*'){
                      _currentQuery = query;
                      // we rebuild the uri when the query changed to go back to page 0
                      _from = 0;
                      _lastUri  = _getSearchUrl(_from);
                   }

                   return _lastUri.replace("%QUERY", encodeURIComponent(query))
                },
                filter: _parseResponse
            }
        });

        _typeaheadQueryEngine.initialize();

        _$input.typeahead(null, {
            name: definition,
            displayKey: 'title',
            source: _typeaheadQueryEngine.ttAdapter(),
            templates: {
                header: function() {
                    var resultStr = sprintf(core.translateString("recordm.instances", "instance.field.ref.num-results-header"), _totalSearchResults),
                        $header = $('<div class="tt-header-container"><p class="tt-header">' + _confs.header + '</p></div>');

                    if(_totalSearchResults > _confs.maxRows){
                       $(".tt-header",$header).append('<span class="tt-header-results">' + resultStr + '</span>');
                    }

                    return $header;
                },
                suggestion: function(data) {
                    return tmpl(data);
                },
                footer: function(){
                    var $footer = $("<div class='tt-footer'></div>"),
                        previousLinkText = sprintf(core.translateString("recordm.instances", "instance.field.ref.previous-results"), _confs.maxRows),
                        nextLinkText = sprintf(core.translateString("recordm.instances", "instance.field.ref.next-results"), _confs.maxRows);

                    var numVisibleResults = _numSearchResults + _from,
                        hidePrevLink = (numVisibleResults <= _confs.maxRows),
                        hideNextLink = (numVisibleResults === _totalSearchResults);

                    $footer.append(
                        '<a href="#" class="js-link-previous-ref-results link">'+ previousLinkText +'</a>',
                        '<a href="#" class="js-link-next-ref-results link pull-right">' + nextLinkText +'</a>'
                    );

                    if(hidePrevLink){
                        $(".js-link-previous-ref-results", $footer).addClass("hidden");
                    }

                    if(hideNextLink){
                        $(".js-link-next-ref-results", $footer).addClass("hidden");
                    }

                    if(hidePrevLink && hideNextLink){
                        $footer.addClass("hidden");
                    }

                    return $footer;
                }
            }
        });
    };

    var _updateTypeAheadQuery = function(fromIdx){
        _typeaheadQueryEngine.remote.url = _getSearchUrl(fromIdx);
    };

    var _getSearchUrl = function(fromIdx){
        return 'recordm/definitions/search?def=' + encodeURIComponent(definition)
            + '&q=(' + _confs.query + ') AND (%QUERY*)&from='+ (fromIdx || 0) +'&size=' + _confs.maxRows
            + '&sort=' + encodeURIComponent(_confs.sort || 'id:desc');
    };

    var _refreshSuggestions = function(){
        var currentVal = _$input.val();

        //we need to append * so that search is done always
        _$input.typeahead('val', currentVal + "*");
        _$input.typeahead('open');
        _$input.typeahead('val', currentVal); //hide the * right after the search
        _$input.focus();
    };

    var _render = function() {
        let $typeaheadBtn;

        _$html = $([
            '<div class="tt-wrapper input-append">',
            `<input id="f${_confs.id}" class="js-autocomplete autocomplete field-value cob-field-value" type="text" value="${_labelWhileStillLoading}" placeholder="${_confs.fieldDefinition.name}">`,
            '<button class="btn js-typeahead-btn" type="button" tabindex="-1"><i class="icon-search"/></button>',
            '</div>'
        ].join(''));

        _$input = _$html.find(".js-autocomplete");

        if (_confs.cssClasses) {
            _$input.addClass(_confs.cssClasses);
        }

        if (!_confs.readonly) {
            _addTypeAheadToInput();

            _$input.on('typeahead:selected', _onSelect);
            _$input.on('typeahead:closed', _onClose);

            // overwriting typeahead transparent background
            _$input.css("background-color", "#fff");

            $typeaheadBtn = _$html.find(".js-typeahead-btn");
            $typeaheadBtn.click(_refreshSuggestions);

            _$html.on("click", ".js-link-previous-ref-results", function(e){
                e.preventDefault();

                _from -= _confs.maxRows;

                _updateTypeAheadQuery(_from);
                _refreshSuggestions();
            });

            _$html.on("click", ".js-link-next-ref-results", function(e){
                e.preventDefault();

                _from += _confs.maxRows;

                _updateTypeAheadQuery(_from);
                _refreshSuggestions();
            });

        } else {
            _$input.attr("readonly", "readonly").attr("tabindex", -1);
        }

        if (_selectedIndexedInstance) {
            _onSelect(undefined, {entity: _selectedIndexedInstance});
        }

        return _$html;
    };

    var _clearError = function() {
        _$input.removeClass("error");
    };

    var _showError = function() {
        _$input.addClass("error");
    };

    var _destroy = function() {
        if (!_confs.readonly) {
            _$input.off('typeahead:selected', _onSelect);
            _$input.off('typeahead:closed', _onClose);

            _$input.typeahead('destroy');
        }

        if (_selectedIndexedInstance) {
            _selectedIndexedInstance.release();
        }
    };

    const _removeValue = function (){
        _valueWhileStillLoading = undefined;
        _selectedIndexedInstance = undefined;

        _removeRefLink();

        if(_$input){
            _$input.val('');

            // let's notify that the selected value changed
            if (_confs.valueChanged) {
                _confs.valueChanged(undefined);
            }
        }
    }

    const _addRefLink = function (){
        //TODO JF: Mostrar detalhes inline na página?
        $(`.js-${_confs.id}-ref-link`)
            .attr("href", `#/${UriBuilder.buildUriForInstance(_selectedIndexedInstance.getId())}`)
            .removeClass("hidden");
    };

    const _removeRefLink = function (){
        $(`.js-${_confs.id}-ref-link`).removeAttr("href").addClass("hidden");
    };

    return {
        render: _render,
        destroy: _destroy,

        clearError: _clearError,
        showError: _showError,

        setValue: function(value, label) {
            if(!value){
                _removeValue();
                return;
            }

            const val = Array.isArray(value) ? value[0] : value

            // we keep this until the reference is loaded, so that getValue() doesn't return indefined
            _valueWhileStillLoading = val;
            // we keep this until the reference is loaded, so that we can use as the starting value for _readTargetField
            _labelWhileStillLoading = label || '';

            _loadReference(val);
        },
        getValue: function() {
            return _selectedIndexedInstance ? _selectedIndexedInstance.data.id : _valueWhileStillLoading;
        },

        disableSelf: function(){
            _previousStyle = _$input.attr("style");
            _$input.prop("readonly", true).attr("tabindex", -1).removeAttr("style");
            _$html.find('.js-typeahead-btn').prop("disabled", true).attr("tabindex", -1)
        },
        enableSelf: function(){
            _$input.removeProp("readonly").removeAttr("tabindex").attr("style", _previousStyle);
            _$html.find('.js-typeahead-btn').removeProp("disabled").removeAttr("tabindex");
        },
        isEnabled: function () {
            return !_$input.prop('readonly');
        },

        // specific functions
        getModel: function() {
            return _selectedIndexedInstance;
        },
        setQuery: function(query){
            _confs.query = query;

            _updateTypeAheadQuery();
        }
    }
};

export default Ref;
